import { flow } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { listTimeZones } from 'timezone-support';
var validTimezones = listTimeZones();
export var isTimezoneValid = flow(function (tz) {
  return O.fromNullable(tz);
}, O.chain(O.fromPredicate(function (tz) {
  return validTimezones.includes(tz);
})));